import {APIError} from 'data/errors';
import {GetHealthCardParams, HealthCard} from 'domain/usecases';
import {makeGetHealthCard} from 'main/factories/usecases';
import {getCurrentAccountAdapter} from 'main/adapters/current-account-adapter';

export const getHealthCard = async ({signal}: GetHealthCardParams) => {
	const {
		beneficiary: {cdUsuarioC},
	} = getCurrentAccountAdapter();

	const response = await makeGetHealthCard().get({signal});

	if (response instanceof APIError) {
		throw response;
	}

	const beneficiaryCard = response.find(card => card.cdUsuarioC === cdUsuarioC);

	if (!beneficiaryCard) {
		throw new Error();
	}

	const formattedBeneficiaryCard = {
		...beneficiaryCard,
		nmPlano: beneficiaryCard.nmPlano.toUpperCase(),
	} as HealthCard;

	return formattedBeneficiaryCard;
};
